import { render, staticRenderFns } from "./MachinesRentsPage.vue?vue&type=template&id=3a58cac2&scoped=true&"
import script from "./MachinesRentsPage.vue?vue&type=script&lang=js&"
export * from "./MachinesRentsPage.vue?vue&type=script&lang=js&"
import style0 from "./MachinesRentsPage.vue?vue&type=style&index=0&id=3a58cac2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58cac2",
  null
  
)

component.options.__file = "MachinesRentsPage.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VChip,
  VContainer,
  VDataTable,
  VDatePicker,
  VFlex,
  VIcon,
  VLayout,
  VMenu,
  VProgressLinear,
  VSnackbar,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarTitle,
})
